<div class="success-modal">
  <div class="header">
    <div class="title">Success</div>

    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      (click)="close()"
    >
      ×
    </button>
  </div>

  <div class="body">
    <div class="headline">Your catalog suggestion has been submitted.</div>
    <div class="subtext">
      You will receive an email when action has been taken to your suggestion.
    </div>
  </div>

  <div class="divider"></div>

  <div class="actions">
    <app-button [text]="'OK'" (click)="close()"></app-button>
  </div>
</div>
